import React, { useEffect, useState } from "react";
import { CitiesCount, SpotlightCount } from "../Utils/TableHeadlist";
import {
  useGetDashboardSpotlightInsightsQuery,
  useGetDashboardSpotlightQuery,
  useGetDashboardSpotlightfeedbackQuery,
  useGetDashboardTotalCountQuery,
  useGetSpotlightCityMutation,
  useGetSpotlightbyIdMutation,
  useGetSpotlightbyStaticsMutation,
  useGetSpotlightuniquePageclickMutation,
} from "../../../../Service/dashboard";
import TechBridgeCount from "../tech-bridge/TechBridgeCount";
import { Col, Row } from "react-bootstrap";
import ChartBox from "../component/ChartBox";
import Chart from "../component/Chart";
import Feedback from "./Feedback";
import CitiesSpotlight from "./CitiesSpotlight";
import { useDispatch } from "react-redux";
import { Reset } from "../../../../store/async-actions/digitalmarketing/header";
import * as CIIcons from "react-icons/ci";
import Dropdown from "../../../../Component/DigitalMarketing/Forms/Dropdown";
import Store from "../../../../store/Store";
import moment from "moment";
function SpotlightAnalytics() {
  const dispatch = useDispatch();
  const [city, setCity] = useState([]);
  const [service, setService] = useState<any>({});
  const [spotlight, setSpotlight] = useState<any>({});
  const [unique, setUnique] = useState<any>({});
  const [cityspotlight, setCitySpotlight] = useState<any>({});

  let data = { spotlight_id: Store.getState().auth.spotlight_id };
  useEffect(() => {
    dispatch(Reset());
  }, [dispatch]);
  const [getSpotlightCity] = useGetSpotlightCityMutation();
  const [getSpotlightbyId] = useGetSpotlightbyIdMutation();
  const [getSpotlightbyStatics] = useGetSpotlightbyStaticsMutation();
  const [getSpotlightuniquePageclick] =
    useGetSpotlightuniquePageclickMutation();
  useEffect(() => {
    getSpotlightCity(data)
      .then((res: any) => {
        const citySet = new Set<string>();
        const cityArray = res.data?.listing
          .map((item) => ({
            id: item._id.city,
            city: item._id.city,
          }))
          .filter((cityObj) => cityObj.city.trim() !== "")
          .filter((cityObj) => {
            // Check if the city name is not already in the Set
            if (!citySet.has(cityObj.city)) {
              // If it's not in the Set, add it and return true to include in the array
              citySet.add(cityObj.city);
              return true;
            }
            // If it's already in the Set, return false to exclude from the array
            return false;
          });
        
        // console.log(cityArray);
        
        let final = [{ id: "all", city: "All" }, ...cityArray];
        setCity(final);
        setService((prevState) => ({
          ...prevState,
          source: final?.[0]?.id,
        }));
      })
      .catch((err) => {
        console.error(err);
      });
    getSpotlightbyId(data)
      .then((res: any) => {
        // console.log(res.data.listing[0]);
        setSpotlight((prevState) => ({ ...prevState, ...res?.data?.listing[0] }));
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);
  useEffect(() => {
    let payload = {
      ...data,
      from_date: moment(spotlight.spotlight_start_date).format("YYYY-MM-DD"),
      to_date: moment(new Date()).format("YYYY-MM-DD"),
    };
    getSpotlightuniquePageclick(payload)
      .then((res: any) => {
        // console.log(res.data);
        setUnique((prevState) => ({ ...prevState, ...res.data }));
      })
      .catch((err) => {
        console.error(err);
      });
  }, [spotlight]);

  // const { data: Spotlight } = useGetDashboardSpotlightQuery(null, {
  //   refetchOnMountOrArgChange: true,
  // });
  // const { data: SpotlightFeedback } = useGetDashboardSpotlightfeedbackQuery(
  //   null,
  //   {
  //     refetchOnMountOrArgChange: true,
  //   }
  // );
  // const { data: SpotlightInsights } = useGetDashboardSpotlightInsightsQuery(
  //   null,
  //   {
  //     refetchOnMountOrArgChange: true,
  //   }
  // );
  // console.log(spotlight);
  useEffect(() => {
    let payload = {
      ...data,
      from_date: moment(spotlight.spotlight_start_date).format("YYYY-MM-DD"),
      to_date: moment(new Date()).format("YYYY-MM-DD"),
      city: service?.source,
    };
    getSpotlightbyStatics(payload)
      .then((res: any) => {
        // console.log(res.data);
        setCitySpotlight(res.data.listing[0]);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [service?.source, spotlight]);
  let dashboardCountList = [];
  let count = {
    total_views: spotlight?.total_views,
    total_clicks: unique?.total_click,
    total_time_spent: spotlight?.total_time_spent,
    unique_view: unique?.unique_view,
    unique_click: unique?.unique_click,
  };
  if (count) {
    const totalCountValue = Object.values(count);
    dashboardCountList = SpotlightCount.map((item, index) => {
      item.list = totalCountValue[index];
      return item;
    });
  }
  let spotlightInsightsCount = [];
  let Insights = {
    views_average: cityspotlight?.views_average,
    total_clicks: cityspotlight?.total_clicks,
    total_active_users: cityspotlight?.total_active_users,
    total_views: cityspotlight?.total_views,
  };
  if (count) {
    const totalCountValue = Object.values(Insights);
    spotlightInsightsCount = CitiesCount.map((item, index) => {
      item.list = totalCountValue[index];
      return item;
    });
  }
  const onHandleChange = (event) => {
    const { name, value } = event.target;
    setService((prevState) => ({ ...prevState, [name]: value }));
  };
  return (
    <>
      <h3 className="f-20 fw-600">Spotlight </h3>
      <TechBridgeCount CountList={dashboardCountList} />
      <Row className="mt-3 mb-3">
        <Col className="mb-3" md={12} lg={6}>
          <div>
            {/* <ChartBox element={<Chart />} title="Time Spend" /> */}
            <CitiesSpotlight
              filter={
                <div style={{ width: "100px" }}>
                  <Dropdown
                    option={city}
                    ids="id"
                    {...service}
                    defaults="Choose Source..."
                    list_name="city"
                    key_name="source"
                    handleChange={onHandleChange}
                    noDefault={true}
                  />
                </div>
              }
              CountList={spotlightInsightsCount}
            />
          </div>
        </Col>
        <Col className="mb-3" md={12} lg={6}>
          {/* <Feedback /> */}
          <div className="cards h-100">
            <h3 className="f-20 fw-600 mt-2 mb-5">Feedback</h3>
            <div className="d-flex justify-content-around mt-5 mb-5 feedback ">
              <div className="mt-4">
                <CIIcons.CiFaceFrown className="i" />
                <span>{spotlight?.feedbacksad || 0}</span>
              </div>
              <div className="mt-4">
                <CIIcons.CiFaceMeh className="i" />
                <span>{spotlight?.feedbackok || 0}</span>
              </div>
              <div className="mt-4">
                <CIIcons.CiFaceSmile className="i" />
                <span>{spotlight?.feedbackhappy || 0}</span>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
}

export default SpotlightAnalytics;
